export const APP_PROPS = '__domain_group/APP_PROPS';
export const APP_PAGE = '__domain_group/APP_PAGE';
export const APP_ROOT = '__domain_group/APP_ROOT';
